
// This file is auto-generated. Do not edit directly.
// It combines all plugin configs into a single file.

const combinedConfigs = {
        polio: require('/opt/app/plugins/polio/js/config.tsx'),
    registry: require('/opt/app/plugins/registry/js/config.tsx')
};

export default combinedConfigs;
